import cx from 'classnames'
import { useDevice } from 'device'
import { usePathname } from 'router'
import React, { forwardRef, ReactNode } from 'react'

import s from './WidthContainer.scss'


type WidthContainerProps = {
  children?: ReactNode
  className?: string
  id?: string
  ignore?: boolean
  narrow?: boolean
  dataTestId?: string
}

const WidthContainer = forwardRef<HTMLDivElement, WidthContainerProps>((props, ref) => {
  const { children, className, id, ignore, narrow, dataTestId } = props

  const { isMobile, isTablet } = useDevice()
  const pathname = usePathname()
  const isHomePage = pathname === '/'

  const paddingClassName = isMobile ? 'px-24px' : isTablet ? 'px-32px' : 'px-40px'

  const rootClassName = cx(className, {
    [paddingClassName]: !ignore,
    [s.widthContainer]: !ignore,
    [s.homePage]: !ignore && isHomePage,
    'mw-618': !ignore && narrow,
  })

  return (
    <div ref={ref} id={id} className={rootClassName} data-testid={dataTestId}>
      {children}
    </div>
  )
})

WidthContainer.displayName = 'WidthContainer'


export default WidthContainer
